module.exports = __webpack_public_path__ + "img/package-1.bb4b5b1d.png";